export const CanSignStationUserStatus = {
	None: 'None',
	Notified: 'Notified',
} as const;

export const PastStationUserStatuses = {
	Approved: 'Approved',
	Rejected: 'Rejected',
	Canceled: 'Canceled',
	Alert: 'Alert',
	TimedOut: 'TimedOut',
} as const;

export const StationUserStatus = {
	...CanSignStationUserStatus,
	...PastStationUserStatuses,
} as const;

export type StationUserStatus = (typeof StationUserStatus)[keyof typeof StationUserStatus];
